import { FC, useMemo, useContext } from 'react';
import useTrials from '@/hooks/data/useTrials';
import TrialsContext, { ITrialsContext } from '@/contexts/data/TrialsContext';
import { TrialGetCollection } from '@/api/dtos';
import { IHasChildren } from '@ngt/forms';
import { useInRouterContext, useParams, useMatch } from 'react-router-dom';
import TrialContext, { ITrialContext } from '@/contexts/data/TrialContext';


export interface ITrialProviderProps extends IHasChildren {
}

export const TrialProvider: FC<ITrialProviderProps> = ({ children }) => {
    const trials = useContext(TrialsContext);

    const trialCode = useMatch('/:trialCode/*')?.params?.trialCode;

    const trial  = useMemo(() => {
        if (!trialCode) {
            return {
                data: undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as ITrialContext;
        }

        return {
            data: trials.data?.find(x => x.code === trialCode),
            code: trialCode,
            error: trials.error,
            loading: trials.loading,
            validating: trials.validating,
            refresh: async () => {
                const newData = await trials.refresh();

                return newData?.find(x => x.code === trialCode);
            },
        } as ITrialContext
    }, [trials, trialCode]);

    return (

        <TrialContext.Provider value={trial}>
            {children}
        </TrialContext.Provider>
    );
}

export default TrialProvider;
